/**
 * 지나치게 많은 요청인 경우의 에러
 */
 export default class TooManyRequestsError extends Error {}